import { Tabs } from '@/components/UI/Tabs'
import { useEffect, useRef } from 'react'

export type TabItem = {
  id: number
  label: string
}

type Props = {
  tabs: TabItem[]
  activeIndex: number
  onChange: (index: number) => void
  className?: string
}

/**
 * 複数特典がある場合に表示するタブコンポーネント。
 * タブが 1 件以下の場合は非表示になる。
 * タブが 3 件以上の場合は横スクロール可能になり、アクティブタブを中央に自動スクロールする。
 * Figma: node 553-19049
 */
export function RewardDetailTabs({ tabs, activeIndex, onChange, className }: Props) {
  const wrapperRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const wrapper = wrapperRef.current
    if (!wrapper) return
    const activeTab = wrapper.querySelectorAll('[role="tab"]')[activeIndex] as HTMLElement | undefined
    activeTab?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' })
  }, [activeIndex])

  if (tabs.length <= 1) return null

  const isScrollable = tabs.length >= 3

  return (
    <div ref={wrapperRef}>
      <Tabs
        tabs={tabs.map((t) => t.label)}
        activeIndex={activeIndex}
        onChange={onChange}
        ariaLabel="特典切り替え"
        className={className}
        scrollable={isScrollable}
      />
    </div>
  )
}
